import config from '../config/config';

const DEFAULT_ANIMATION_DURATION_MS = Number(config.map.animationDurationMs);
const DEFAULT_PITCH = Number(config.map.defaultPitch);
const DEFAULT_BEARING = Number(config.map.defaultBearing);
const PITCH_FOR_3D_MODE = Number(config.map.pitchFor3dMode);

/**
 * 3Dモード関数
 */
export function toggle3dMode(map, after3dMode) {
  if (!map) {
    return false;
  }

  try {
    // 有効になる方
    if (after3dMode) {
      map.easeTo({
        pitch: PITCH_FOR_3D_MODE,
        duration: DEFAULT_ANIMATION_DURATION_MS
      });

    } else {
      // 無効になる方
      map.easeTo({
        pitch: DEFAULT_PITCH,
        bearing: DEFAULT_BEARING,
        duration: DEFAULT_ANIMATION_DURATION_MS
      });
    }
    return true;
  } catch (e) {
    return false;
  }
}
